export enum CommonPageComponents {
  SegmentSliderUI = 'SegmentSliderUI',
  SearchWidget = 'SearchWidget',
  LoginBanner = 'LoginBanner',
  AlternateDates = 'AlternateDates',
  PageHeader = 'PageHeader',
  Calendar = 'Calendar',
  PaxScreen = 'PaxScreen',
}

export enum CommonPageEvents {
  checkAvailabilityClick = 'seo_check_availability_clicked',
  selectDatesClickedExp = 'Select_dates_clicked_exp',
  viewSimilarPropertiesClicked = 'viewsimilarproperties_clicked',
  viewAllPropertiesClicked = 'viewAllproperties_clicked',
}

export enum SearchWidgetTrack {
  Location = 'location',
  CheckInCheckOut = 'checkInCheckOut',
  Pax = 'pax',
  UpdateSearch = 'update_search',
  GeoEntityChange = 'geo_entity_change',
}

export const calendarClicks = {
  paxClicked: 'Search widget_PAX_selected',
  calendarOpen: 'Calendar_open',
  calendarDone: 'Calendar_done',
  timePickerOpen: 'TimePicker_open',
  timePickerDone: 'TimePicker_done',
  dateClicked: 'Date_Clicked',
  timeClicked: 'Time_clicked',
  timeSelected: 'Time_selected',
  checkinClicked: 'Checkin_clicked',
  checkoutClicked: 'Checkout_clicked',
  continueClicked: 'Search Widget_Continue_clicked',
};

export enum SRPListingDynamicCards {
  TopFilterCard = 'INDIANNESS',
  PolarisCard = 'POLARIS',
}
